import { usePageNumberFromUrl, usePerPageValueFromUrl, useSortValueFromUrl } from 'idsk-react-components';
import { SortDirectionEnum } from 'elegislativa-frontend-ts-axios';
import { ClientStatus } from '../../../../model/ClientStatus';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import {
  fetchSledovanyLegislativnyMaterialPage,
} from '../../../../client/legislativnyMaterial/sledovanyLegislativnyMaterialListClient';
import { defaultPerPageValue, perPageDataArray } from '../../../../constants/PaginationPerPageConstants';
import useSearchTextFilterFromUrl from '../../../../hooks/useSearchTextFilterFromUrl';
import LegislativnyMaterialFilterListPage
  from '../../../../model/legislativnyMaterial/LegislativnyMaterialFilterListPage';

interface ReturnType {
  legislativnyMaterialPage: LegislativnyMaterialFilterListPage;
  requestStatus: ClientStatus;
  pageNumber: number;
  searchText: string;
  reloadMaterialPage
}

const getSort = (sortValue): string => {
  if (sortValue !== 'typPredpis' && sortValue !== 'nazov' && sortValue !== 'stavPredpis') {
    return 'cisloLP';
  }
  return sortValue;
};

const getSortByEnum = (sort): SortDirectionEnum => (sort[1] === 'desc' || sort[1] === '' ? SortDirectionEnum.Desc
  : SortDirectionEnum.Asc);

export default (): ReturnType => {
  const { page } = usePageNumberFromUrl();
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray, defaultPerPageValue);
  const { sort } = useSortValueFromUrl();
  const filter = useSearchTextFilterFromUrl();
  const {
    data: legislativnyMaterialPage,
    status: requestStatus,
    refetch: reloadMaterialPage,
  } = useClientFetch(
    fetchSledovanyLegislativnyMaterialPage,
    [page, perPageValue, getSort(sort[0]), getSortByEnum(sort), filter ? filter.trim() : filter],
    [page, perPageValue, sort[0], sort[1], filter],
  );

  return {
    legislativnyMaterialPage,
    requestStatus,
    pageNumber: page,
    searchText: filter,
    reloadMaterialPage,
  };
};
